export default "__VITE_ASSET__DNiPzI1J__"